export const colFormRef = 'col-page-search-form-ref';
